import React from "react";
import {
  Container,
  Title,
  SubTitle,
  LicenseSubTitle,
  Content,
  LicenseContent,
  LicenseLabel,
  LicenseNumber,
  Wrapper,
  ContentsContainer,
  ImageContainer,
  LicenseImageContainer,
  StyledImg,
  SmallImageContainer,
  StyledSmallImg,
  InLineImgContainer,
  InLineImgContentgContainer,
  OutLineImgContent,
  InLineImgContent,
} from "./styles";
import Image from "./Images";
import PageContainer from "../PageContainer";
import { Breadcrumb, BreadcrumbItem } from "../Breadcrumb";
const OurTeam = () => {
  const image = Image();
  return (
    <>
      <Breadcrumb pageTitle="Our Team">
        <BreadcrumbItem Link="/our-Team" Text="Our Team" />
      </Breadcrumb>

      <PageContainer>
        <Container>
          <Container>
            <Content>
              Our staff aim to provide you with a personalised and enjoyable
              experience during your orthodontic journey. Our team aims to
              provide you with clinical excellence by using the latest
              orthodontic principles and techniques.
            </Content>
            <Content>
              There are many people in the Gippsland Orthodontic team who assist
              our orthodontist in giving you the best possible outcome in your
              treatment.
            </Content>
            <Title>Meet our team at Gippsland Orthodontics</Title>

            <SubTitle>WILL – Finance Manager</SubTitle>
            <Wrapper>
              <ImageContainer>
                <StyledImg fluid={image.will} />
              </ImageContainer>

              <ContentsContainer>
                <Content>
                  Will brings a strong background in management to the Gippsland
                  Orthodontics team, where he's excited to learn all things
                  orthodontics! Originally from Latrobe in Northern Tasmania, he
                  later moved to Melbourne and worked as a relationship manager
                  for several companies in the finance industry.
                </Content>
                <Content>
                  Will loves seeing the transformations patients go through and
                  the happiness it brings them throughout their orthodontic
                  journey. He’s also well known for handing out special treats
                  to patients—especially when they’re a little hangry!
                </Content>
                <Content>
                  In his spare time, Will enjoys spending time with family and
                  friends, especially the four-legged kind. He can never resist
                  a hello or cuddle from any animal, particularly his beloved
                  dog, Hughie.
                </Content>
              </ContentsContainer>
            </Wrapper>

            <SubTitle>MEGAN – Practice Manager</SubTitle>
            <Wrapper>
              <ImageContainer>
                <StyledImg fluid={image.megan} />
              </ImageContainer>
              <ContentsContainer>
                <Content>
                  With nearly 35 years of experience in orthodontics, Megan is
                  passionate about her work and finds it a true privilege to
                  watch patients grow in confidence as they achieve beautiful
                  smiles. She finds it incredibly rewarding to build lasting
                  relationships and witness not only the transformation of their
                  smiles but also their self-esteem and confidence.
                </Content>
                <Content>
                  Outside of work, Megan enjoys spending time with family and
                  friends. Her interests include cooking, travelling, hiking,
                  and relaxing at the beach.
                </Content>
              </ContentsContainer>
            </Wrapper>

            <LicenseSubTitle>TAYLA – Oral Health Therapist</LicenseSubTitle>
            <LicenseContent>
              <LicenseLabel>AHPRA Registration Number:</LicenseLabel>{" "}
              <LicenseNumber>DEN0002120143</LicenseNumber>
            </LicenseContent>
            <Wrapper>
              <LicenseImageContainer>
                <StyledImg fluid={image.tayla} />
              </LicenseImageContainer>
              <ContentsContainer>
                <Content>
                  Since graduating from La Trobe University in 2017, Tayla has
                  been brightening little smiles as a dedicated Oral Health
                  Therapist, with a special focus on paediatric dentistry. Her
                  calm, friendly approach helps even the littlest patients feel
                  comfortable and confident in the dental chair.
                </Content>
                <Content>
                  Tayla is now expanding her skills and stepping into an
                  exciting new role in orthodontics, where she’s looking forward
                  to helping patients of all ages achieve their dream smiles.
                  Her passion for creating positive dental experiences continues
                  to shine in this new chapter of her career.
                </Content>
                <Content>
                  When Tayla isn’t busy making dental visits fun, she’s a
                  full-time mum to two energetic little girls, Zara and Adelyn.
                  Life at home is full of dance parties in the living room,
                  delicious baking adventures, and trying out new lunch spots
                  whenever she can squeeze in some grown-up time.
                </Content>
                <Content>
                  With her warm personality and genuine love for working with
                  children and families, Tayla brings a sense of fun and care to
                  everything she does—whether it’s guiding a child through their
                  first dental visit, assisting with braces, or perfecting her
                  cupcake recipe!
                </Content>
              </ContentsContainer>
            </Wrapper>

            <LicenseSubTitle>ELLE - Oral Health Therapist</LicenseSubTitle>
            <LicenseContent>
              <LicenseLabel>AHPRA Registration Number:</LicenseLabel>{" "}
              <LicenseNumber>DEN0002829954</LicenseNumber>
            </LicenseContent>
            <Wrapper>
              <LicenseImageContainer>
                <StyledImg fluid={image.elle} />
              </LicenseImageContainer>
              <ContentsContainer>
                <Content>
                  Elle began her career in dentistry in 2010, completing her
                  Certificate III in Dental Assisting before advancing her
                  skills with a Certificate IV in Dental Radiography in 2014.
                  With a strong passion for patient care and a love for being
                  actively involved in clinical work, Elle chose to further her
                  studies and graduated with a Bachelor of Oral Health Therapy
                  from Charles Sturt University in 2023.
                </Content>
                <Content>
                  Elle is committed to providing gentle, supportive care and
                  helping patients feel at ease while achieving and maintaining
                  their oral health.
                </Content>
                <Content>
                  Outside the dental practice, she enjoys keeping active with
                  Pilates and spending time with her partner and two daughters.
                </Content>
              </ContentsContainer>
            </Wrapper>

            <SubTitle>JANINE - Receptionist / Treatment Coordinator</SubTitle>
            <Wrapper>
              <ImageContainer>
                <StyledImg fluid={image.janine} />
              </ImageContainer>
              <ContentsContainer>
                <Content>
                  Janine is a dedicated dental professional with extensive
                  experience in the industry, having started her career as a
                  dental nurse straight out of school. Over the years, she has
                  had the opportunity to grow and develop in various roles,
                  including spending 10 years as a practice manager. Most
                  recently, she has expanded her expertise into orthodontics,
                  where she has been fortunate to witness firsthand the
                  incredible transformations in patients’ smiles.
                </Content>
                <Content>
                  Outside of work, Janine enjoys maintaining a healthy lifestyle
                  and keeping fit. She is a proud mum to three grown children
                  and cherishes quality time spent with her family and friends.
                </Content>
              </ContentsContainer>
            </Wrapper>

            <SubTitle>STACEY - Receptionist / Treatment Coordinator</SubTitle>
            <Wrapper>
              <ImageContainer>
                <StyledImg fluid={image.stacey} />
              </ImageContainer>
              <ContentsContainer>
                <Content>
                  Stacey started with Gippsland Orthodontics in 2025, having
                  previously worked in the medical reception field for the last
                  15 years.
                </Content>
                <Content>
                  Stacey loves helping patients and ensuring they’re happy and
                  comfortable. Outside of work, Stacey enjoys spending time with
                  her family and friends, travelling, and snuggling up to a good
                  movie or TV series.
                </Content>
              </ContentsContainer>
            </Wrapper>

            <SubTitle>RACHAEL – Clinical Coordinator</SubTitle>
            <Wrapper>
              <ImageContainer>
                <StyledImg fluid={image.rachael} />
              </ImageContainer>
              <ContentsContainer>
                <Content>
                  Rachael began her dental career in 2013 and has specialised in
                  orthodontics ever since. Her passion for patient care and
                  attention to detail ensures that every smile is in great
                  hands.
                </Content>
                <Content>
                  Outside of work, Rachael enjoys travelling with her husband,
                  spending quality time with their two dogs, Ronnie and Koko,
                  and exploring her creative side through sewing and other
                  crafts. Recently, she’s taken up golf and is excited about
                  improving her game.
                </Content>
              </ContentsContainer>
            </Wrapper>

            <SubTitle>JESSE - Dental Assistant / Clinical Coordinator</SubTitle>
            <Wrapper>
              <ImageContainer>
                <StyledImg fluid={image.jesse} />
              </ImageContainer>
              <ContentsContainer>
                <Content>
                  Jesse is a dedicated dental assistant with a passion for
                  helping others smile. She began her career in the dental field
                  in 2021 and transitioned to orthodontics in 2024, bringing her
                  dental experience and enthusiasm to the team. Jesse enjoys
                  bringing a light-hearted touch to the workplace, often wearing
                  fun and groovy socks that brighten everyone’s day.
                </Content>
                <Content>
                  When she's not assisting patients, Jesse enjoys playing
                  netball and staying active with regular runs. At home, she’s a
                  proud cat mum to Ivy, her beloved “fur baby,” who brings her
                  plenty of joy. Jesse’s commitment to her work, combined with
                  her cheerful spirit, makes her a valued member of the team and
                  a positive influence in the workplace.
                </Content>
              </ContentsContainer>
            </Wrapper>

            <SubTitle>EMILY - Dental Assistant</SubTitle>
            <Wrapper>
              <ImageContainer>
                <StyledImg fluid={image.emilyW} />
              </ImageContainer>
              <ContentsContainer>
                <Content>
                  Em is a qualified dental assistant who completed a Certificate
                  III in Dental Assisting in 2023. She is committed to
                  delivering high-quality patient care and supporting dental
                  professionals in providing efficient and effective treatment.
                  Em consistently maintains a professional and compassionate
                  approach, ensuring a comfortable experience for all patients.
                  Outside of her professional responsibilities, she enjoys
                  camping and spending time with her family and pets.
                </Content>
              </ContentsContainer>
            </Wrapper>

            <SubTitle>JEMMA - Dental Assistant</SubTitle>
            <Wrapper>
              <ImageContainer>
                <StyledImg fluid={image.jemma} />
              </ImageContainer>
              <ContentsContainer>
                <Content>
                  Jemma began her journey in the dental industry in 2019,
                  starting as a Dental Assistant in general dentistry. In 2021,
                  she completed Certificate III in Dental Assisting at Chisholm
                  Institute, further strengthening her knowledge and commitment
                  to high-quality treatment and patient support.
                </Content>
                <Content>
                  In 2022, she transitioned into orthodontics, where she
                  discovered a passion for helping patients build confidence
                  through their smiles and being part of their long-term
                  transformation journey.
                </Content>
                <Content>
                  She prides herself on creating a welcoming, supportive
                  environment and ensuring every patient feels comfortable and
                  cared for.
                </Content>
                <Content>
                  Outside of work, Jemma enjoys camping, spending time with
                  friends and family, and weekend adventures with her partner.
                </Content>
              </ContentsContainer>
            </Wrapper>

            <SubTitle>EMMA - Dental Assistant</SubTitle>
            <Wrapper>
              <ImageContainer>
                <StyledImg fluid={image.emma} />
              </ImageContainer>
              <ContentsContainer>
                <Content>
                  Emma has worked in the dental industry for nearly 30 years,
                  beginning her career in dental nursing and later specialising
                  in oral surgery for seven years before moving into
                  orthodontics. Her extensive experience across multiple areas
                  of dentistry has given her a broad and in-depth understanding
                  of patient care.
                </Content>
                <Content>
                  Emma is passionate about supporting patients throughout their
                  dental journey and takes pride in helping them feel
                  comfortable, informed and confident every step of the way.
                </Content>
                <Content>
                  Outside of work, Emma enjoys spending time with her daughter,
                  family and friends. She is involved in netball and pony club,
                  and in her spare time loves reading and going to the movies.
                </Content>
              </ContentsContainer>
            </Wrapper>

            <SubTitle>HUGHIE</SubTitle>
            <Wrapper>
              <ImageContainer>
                <StyledImg fluid={image.hughie} />
              </ImageContainer>
              <ContentsContainer>
                <Content>
                  Hughie is our most lovable furry team member and takes his
                  role as CPG (Chief Patient Greeter) very seriously, always
                  with a wagging tail. Hughie plays an important role in helping
                  our anxious patients feel calm, comforted, and right at home
                  during their visit.
                </Content>
                <Content>
                  He absolutely adores pats, belly rubs, and being the centre of
                  attention—and if you’re up for it, he’ll happily chase after a
                  ball (or two)!
                </Content>
                <Content>
                  Whether you&#39;re waiting for your appointment or need a
                  moment to relax, Hughie is nearby to offer his gentle
                  presence.
                </Content>
              </ContentsContainer>
            </Wrapper>
          </Container>
        </Container>
      </PageContainer>
    </>
  );
};

export default OurTeam;
